export const DS_CHART_PALETTE_ID = 'ahaslides-ds-2026'

const INK = '#1A1A1A'
const VIVID_PINK_30 = '#F8B7D2'
const INK_INDEXES = [1, 5]

export const DS_CHART_PALETTE = {
  id: DS_CHART_PALETTE_ID,
  title: 'Vivid',
  inkAware: true,
  colors: ['#E70E68', INK, VIVID_PINK_30, '#A8A8A8', '#E70E68', INK],
  lighterColors: ['#FEF3F7', '#F7F7F7', '#FEF3F7', '#F7F7F7', '#FEF3F7', '#F7F7F7'],
}

const RENAMED_PALETTE_TITLES = {
  'branding-2025': 'Coral Mint',
  default: 'Rainbow',
}

export function shouldKeepVividOnThemeApply(isDsChartPaletteEnabled, savedColorPalette) {
  if (!isDsChartPaletteEnabled) return false
  return !savedColorPalette?.colors || savedColorPalette.id === DS_CHART_PALETTE_ID
}

export function resolveInkAwarePalette(colors, slideTextColour) {
  const ink = slideTextColour || INK
  return colors.map((colour, index) => (INK_INDEXES.includes(index) ? ink : colour))
}

export function arrangePresetColorPalettes(palettes, isDsChartPaletteEnabled) {
  const dsPalettes = palettes.filter((palette) => palette.id === DS_CHART_PALETTE_ID)
  const otherPalettes = palettes.filter((palette) => palette.id !== DS_CHART_PALETTE_ID)
  if (!isDsChartPaletteEnabled) return otherPalettes
  // An API that predates the DS palette still gets it from the bundle, so the flag never depends on the API deploy.
  const leadingPalettes = dsPalettes.length || !otherPalettes.length ? dsPalettes : [DS_CHART_PALETTE]
  const retitledPalettes = otherPalettes.map((palette) => (
    RENAMED_PALETTE_TITLES[palette.id] ? { ...palette, title: RENAMED_PALETTE_TITLES[palette.id] } : palette
  ))
  return [...leadingPalettes, ...retitledPalettes]
}
